module.exports = __webpack_public_path__ + "static/media/plane.041a99a2.svg";